/**
 * protocol.ts — binary media frame wire format (mirror of server/src/protocol.ts).
 * Keep the two in sync. See the server copy for the header layout.
 */
export const HEADER_BYTES = 14;
export const TRACK_VIDEO = 0;
export const TRACK_AUDIO = 1;
export const TYPE_DELTA = 0;
export const TYPE_KEY = 1;

export interface MediaHeader {
    streamId: number;
    track: number;
    type: number;
    timestamp: number; // microseconds
}

export function encodeFrame(h: MediaHeader, payload: Uint8Array): Uint8Array {
    const buf = new ArrayBuffer(HEADER_BYTES + payload.byteLength);
    const dv = new DataView(buf);
    dv.setUint32(0, h.streamId >>> 0, false);
    dv.setUint8(4, h.track & 0xff);
    dv.setUint8(5, h.type & 0xff);
    dv.setFloat64(6, h.timestamp, false);
    new Uint8Array(buf, HEADER_BYTES).set(payload);
    return new Uint8Array(buf);
}

export function decodeHeader(data: Uint8Array): MediaHeader | null {
    if (data.byteLength < HEADER_BYTES) return null;
    const dv = new DataView(data.buffer, data.byteOffset, data.byteLength);
    return {
        streamId: dv.getUint32(0, false),
        track: dv.getUint8(4),
        type: dv.getUint8(5),
        timestamp: dv.getFloat64(6, false),
    };
}

export function payloadOf(data: Uint8Array): Uint8Array {
    return data.subarray(HEADER_BYTES);
}
